<template>
  <div class="tusd-wrap wrap-bg">
    <div class="page-title"><i class="back-btn" @click="goBack"></i>{{banner.Title}}</div>
    <div class="separator"></div>
    <div class="account-wrap auth-info">
    	<div v-html="banner.Contents"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'banner',
  data(){
  	return {
		  banner:{}
  	}
  },
  methods:{
  	goBack(){
  		this.$router.push({name:"index"})
  	}
  },
  mounted(){//加载页面
   let that=this;
   let bannerId=that.$route.params.bannerId;
   that.$api.getBannerById(bannerId).then(res=>{
		 that.banner=res.data
	})
  },
  created(){
  }
}
</script>

<style lang="less" scoped>
	.auth-info{
		padding:14px 26px 26px;
	}
	.account-wrap{
		    color: #d9e3fd;
	}
	
</style>
